import { rem } from '@heathmont/moon-utils';
import styled, { css } from 'styled-components';
import type ArticleType from '~/client/components/Blog/shared/articles/BlogArticle/ArticleType';
import media from '~/client/shared/media';

const baseContainerStyle = (theme: Theme, gridArea?: string) => css`
  position: relative;
  grid-area: ${gridArea ? gridArea : 'auto'};
  width: auto;
  max-width: ${rem(580)};
  color: ${theme?.color?.bulma[100]};
`;

const articleContainerStyle = css`
  width: auto;
`;

const landscapeContainerStyle = [
  articleContainerStyle,
  css`
    float: none;
    clear: both;
    overflow: hidden;
    width: auto;
    ${media.tabletSmall} {
      max-width: ${rem(580)};
      clear: none;
    }
  `,
];

const recentPostsContainerStyle = css`
  float: left;
  width: calc(50% - ${rem(10)});
`;

const sliderContainerStyle = css`
  outline: none;
  width: auto;
`;

const bigSizeStyle = css`
  width: auto;
  max-width: none;
  ${media.tabletSmall} {
    width: auto;
    max-width: ${rem(580)};
  }
`;

const STYLES_MAP = {
  article_container: articleContainerStyle,
  combo_container: articleContainerStyle,
  landscape: landscapeContainerStyle,
  recent_posts: recentPostsContainerStyle,
  slider: sliderContainerStyle,
};

type Props = {
  type: ArticleType;
  size?: 'big' | 'small';
  gridArea?: string;
  children: React.ReactNode;
};

const Container = styled.div<Props>(({ size, type, theme, gridArea }) => [
  baseContainerStyle(theme, gridArea),
  STYLES_MAP[type],
  size === 'big' && bigSizeStyle,
]);

export default Container;
